import React from 'react';
import ReactDOM from 'react-dom';
import { usePlansService } from 'nekst-api';
import { Button, ButtonColor, ButtonSize } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import { FIX_HIERARCHY_PORTAL_ID } from '../tasks/List/Filter/PlanFilterContainer';
import useUserSessionStorage from '../../login/userSessionStorage';

export default function FixHierarchyButton(props: { planId: number }) {
  const featureToggle = useFeatureToggleService();
  const plansService = usePlansService();
  const sessionStorage = useUserSessionStorage();

  if (!featureToggle.isFixHierarchyEnabled() && !sessionStorage.hasImpersonatedToken()) {
    return null;
  }

  const container = document.getElementById(FIX_HIERARCHY_PORTAL_ID);

  if (!container) {
    return null;
  }

  return ReactDOM.createPortal(
    <Button
      text="Fix Hierarchy"
      size={ButtonSize.MEDIUM}
      color={ButtonColor.YELLOW}
      onClick={async () => {
        await plansService.fixHierarchy(props.planId);
        alert('Hierarchy fixed successfully');
      }}
    />,
    container,
  );
}
